import { render } from "./MultipleSelect.vue?vue&type=template&id=023cf860&scoped=true"
import script from "./MultipleSelect.vue?vue&type=script&lang=js"
export * from "./MultipleSelect.vue?vue&type=script&lang=js"

import "./MultipleSelect.vue?vue&type=style&index=0&id=023cf860&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-023cf860"]])

export default __exports__